<template>
  <div>
    <a-modal
      title="资源发放"
      :visible="visible"
      :mask-closable="false"
      :width="750"
      :confirm-loading="loading"
      destroy-on-close
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button
          @click="handleCancel"
        >
          取消
        </a-button>

        <a-popconfirm
          title="资源超发，请确认信息"
          ok-text="确认"
          cancel-text="取消"
          :visible="vocherPopVisible"
          @confirm="confirmVocherResource"
          @cancel="vocherVisibleCancel"
        >
          <a-popconfirm
            title="资源超发，请确认信息"
            ok-text="确认"
            cancel-text="取消"
            :visible="popVisible"
            @confirm="confirmReleaseResource"
            @cancel="popVisibleCancel"
          >
            <a-button
              key="submit"
              type="primary"
              @click="handleOk"
            >
              确认
            </a-button>
          </a-popconfirm>
        </a-popconfirm>
      </template>
      <a-form-model
        ref="form"
        :model="form"
        label-align="right"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 16 }"
        :rules="validateRules"
      >
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item
              label="基地"
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                @select="selectBase()"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              label="产品类型:"
              prop="productTypeId"
            >
              <a-select
                v-model="form.productTypeId"
                placeholder="请选择产品类型"
                allow-clear
                show-search
                :filter-option="filterOption"
                @select="selectProduct"
              >
                <a-select-option
                  v-for="item in productTypetions"
                  :key="item.productTypeId"
                >
                  {{ item.productTypeName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <div v-if="visibleGrant">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="产品名称:"
                prop="productId"
              >
                <a-select
                  v-model="form.productId"
                  placeholder="请选择产品名称"
                  allow-clear
                  @select="selectByProductId"
                >
                  <a-select-option
                    v-for="item in productNames"
                    :key="item.productId"
                  >
                    {{ item.productName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                prop="taxRate"
                label="产品税率:"
              >
                <a-input-number
                  v-model="form.taxRate"
                  placeholder="请填写产品税率"
                  :formatter="value => `${value}%`"
                  :parser="value => value.replace('%', '')"
                  :disabled="true"
                  :min="0"
                  style="width: 100%;"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="企业名称:"
                prop="enterpriseName"
              >
                <a-input
                  v-model="form.enterpriseName"
                  placeholder="请填写企业名称"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                label="营业执照:"
                prop="businessLicense"
              >
                <a-input
                  v-model="form.businessLicense"
                  placeholder="请填写营业执照"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="开通时间:"
                prop="startDate"
                :rules="validateRules.startDate"
              >
                <a-date-picker
                  v-model="form.startDate"
                  show-time
                  format="YYYY-MM-DD"
                  placeholder="起始时间"
                  suffix-icon=" "
                  style="width: 100%;"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                label="到期时间:"
                prop="endDate"
                :rules="validateRules.endDate"
              >
                <a-date-picker
                  v-model="form.endDate"
                  show-time
                  format="YYYY-MM-DD"
                  placeholder="到期时间"
                  suffix-icon=" "
                  style="width: 100%;"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="云账号:"
                prop="cloudAccount"
              >
                <a-input
                  v-model="form.cloudAccount"
                  placeholder="请填写云账号"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                label="邮箱:"
                prop="email"
              >
                <a-input
                  v-model="form.email"
                  placeholder="请填写邮箱"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="联系人:"
                prop="contactName"
              >
                <a-input
                  v-model="form.contactName"
                  placeholder="请填写联系人"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                label="手机号码:"
                prop="contactPhone"
              >
                <a-input
                  v-model="form.contactPhone"
                  placeholder="请填写手机号码"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col
              v-if="voucherVisible"
              :span="12"
            >
              <a-form-model-item
                label="代金券编号:"
                prop="voucherCode"
              >
                <a-input
                  v-model="form.voucherCode"
                  placeholder="请添加代金券编号"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                label="备注:"
                prop="remark"
              >
                <a-input
                  v-model="form.remark"
                  placeholder="请添加备注"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="外采金额"
                prop="externalProcurementAmount"
              >
                <a-input
                  v-model="form.externalProcurementAmount"
                  placeholder="请填写外采金额"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                label="已付款金额:"
                prop="amountPaid"
              >
                <a-input
                  v-model="form.amountPaid"
                  placeholder="请填写已付款金额"
                />
              </a-form-model-item>
            </a-col>
          </a-row>

          <strong>相关资源配置</strong>
          <div class="table">
            <a-table
              :data-source="dataSource"
              :loading="loading"
              :columns="columns"
              :pagination="false"
              :row-key="(item, index) => index"
            />
          </div>

          <div
            class="amountClass"
          >
            <div class="a-pad">
              合计剩余额度：{{ remainAmount }}
            </div>
            <div v-if="voucherVisible">
              <div class="a-pad">
                运营商剩余可用配额：{{ operatorAmout }}
              </div>
              <div class="a-pad">
                运营商最大可申请配额：{{ distributionAmount }}
              </div>
            </div>
          </div>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item
                label="补贴额度:"
                prop="subsidyAmount"
              >
                <a-input
                  v-model="form.subsidyAmount"
                  placeholder="请输入补贴额度"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { querySubsidyType, queryResourceOthers, queryResourceAllocation, queryProduct, releaseResource, releaseVoucherRsource, queryProductFlowDetail, updateVoucherResource } from '@/api/flowDetail.js'
import moment from 'moment'
import { dateChange, filterOption } from '@/utils/utils.js'

const columns = [
  {
    title: '运营年度归属',
    dataIndex: 'operatorYear',
    key: 'operatorYear'
  },
  {
    title: '资源配置',
    dataIndex: 'productTypeNameList',
    key: 'productTypeNameList'
  },
  {
    title: '折扣比例',
    dataIndex: 'ratio',
    key: 'ratio'
  },
  {
    title: '资源包剩余额度',
    dataIndex: 'remainAmount',
    key: 'remainAmount'
  }
]
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    initData: {
      type: Object,
      default: function () { return {} }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    editVoucherVisible: {
      type: Boolean,
      default: false
    },
    productTypetions: {
      type: Array,
      default: function () { return [] }
    },
    baseOptions: {
      type: Array,
      default: function () { return [] }
    }
  },
  data () {
    const validateStartDate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择开通时间'))
      } else {
        if (value > moment(this.form.endDate).valueOf()) {
          callback(new Error('开通时间应早于结束时间'))
        }
        callback()
      }
    }
    const validateEndDate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择到期时间'))
      } else {
        if (value < moment(this.form.startDate).valueOf()) {
          callback(new Error('到期时间应晚于开通时间'))
        }
        callback()
      }
    }
    return {
      loadingGrant: false,
      visibleGrant: false,
      confirmLoadingGrant: false,
      popVisible: false,
      vocherPopVisible: false,
      voucherVisible: false,
      form: {
        startDate: null,
        endDate: null,
        recoveryDate: null,
        enterpriseName: null,
        baseId: undefined,
        baseName: undefined,
        productTypeId: undefined,
        taxRate: null,
        remark: null,
        cloudAccount: null,
        email: null,
        contactName: null,
        contactPhone: null,
        productId: null,
        subsidyAmount: null,
        businessLicense: null,
        voucherCode: null,
        externalProcurementAmount: null,
        amountPaid: null
      },
      subsidyId: '',
      columns,
      dataSource: [],
      distributionAmount: '',
      operatorAmout: '',
      remainAmount: '',
      validateRules: {
        baseId: [{ required: true, message: '请选择基地', trigger: 'change' }],
        productTypeId: [{ required: true, message: '请输入产品类型', trigger: 'change' }],
        productId: [{ required: true, message: '请选择产品', trigger: 'change' }],
        enterpriseName: [{ required: true, message: '请选择企业名称', trigger: 'change' }],
        startDate: [{ required: true, validator: validateStartDate, trigger: 'change' }],
        endDate: [{ required: true, validator: validateEndDate, trigger: 'change' }],
        subsidyAmount: [{ required: true, message: '请选择补贴金额', trigger: 'change' }],
        voucherCode: [{ required: true, message: '请选择代金券编号', trigger: 'change' }]
      },
      isSelectProduct: false,
      isSelectBase: false,
      productNames: [],
      subsidyAmount: undefined
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: async function (data) {
        if (data) {
          this.voucherVisible = this.editVoucherVisible
          this.initData.startDate = this.initData.startDate
            ? moment(this.initData.startDate).format('YYYY-MM-DD')
            : null

          this.initData.endDate =
          this.initData.endDate
            ? moment(this.initData.endDate).format('YYYY-MM-DD')
            : null

          this.initData.recoveryDate =
          this.initData.recoveryDate
            ? moment(this.initData.recoveryDate).format('YYYY-MM-DD')
            : null

          this.subsidyAmount = this.initData.subsidyAmount

          Object.assign(this.form, this.initData)

          if (this.form.baseId && this.form.productTypeId) {
            this.queryTable()
            await queryProductFlowDetail({
              productTypeId: this.form.productTypeId
            }).then((data) => {
              this.productNames = data
            })
          }
        }
      }
    }
  },
  methods: {
    moment,
    dateChange,
    filterOption,
    handleCancel () {
      this.$refs.form.resetFields()
      this.visibleGrant = false
      this.$emit('cancel')
    },
    selectBase () {
      this.isSelectBase = true
      this.selectGrantResource(this.isSelectProduct, this.isSelectBase)
      if (this.form.baseId && this.form.productTypeId) {
        this.queryTable()
      }
    },
    async selectProduct () {
      this.isSelectProduct = true
      this.form.productId = undefined
      this.form.taxRate = undefined
      this.selectGrantResource(this.isSelectProduct, this.isSelectBase)
      if (this.form.baseId && this.form.productTypeId) {
        this.queryTable()
      }
      await queryProductFlowDetail({
        productTypeId: this.form.productTypeId
      }).then((data) => {
        this.productNames = data
      })
    },
    async selectByProductId (value) {
      await queryProduct({
        productId: value
      }).then((data) => {
        this.form.taxRate = data.taxRate
      })
    },
    releaseRes () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.voucherVisible) {
            if (!this.isEdit) {
              releaseVoucherRsource({
                ...this.form,
                startDate: this.dateChange(moment(this.form.startDate)),
                endDate: this.dateChange(moment(this.form.endDate)),
                recoveryDate: this.dateChange(moment(this.form.recoveryDate)),
                operation: 2,
                dataSource: 1111
              }).then((data) => {
                if (data) {
                  this.$message.success('提交成功')
                  this.$emit('ok')
                } else {
                  this.vocherPopVisible = true
                }
              })
            } else {
              updateVoucherResource({
                ...this.form,
                startDate: this.dateChange(moment(this.form.startDate)),
                endDate: this.dateChange(moment(this.form.endDate)),
                recoveryDate: this.dateChange(moment(this.form.recoveryDate)),
                operation: 2,
                dataSource: 1111
              }).then((data) => {
                if (data) {
                  this.$message.success('提交成功')
                  this.$emit('ok')
                } else {
                  this.vocherPopVisible = true
                }
              })
            }
          } else {
            releaseResource(
              {
                ...this.form,
                startDate: this.dateChange(moment(this.form.startDate)),
                endDate: this.dateChange(moment(this.form.endDate)),
                recoveryDate: this.dateChange(moment(this.form.recoveryDate)),
                operation: 2,
                dataSource: 1111
              }
            )
              .then((data) => {
                if (data) {
                  // 其他类型，弹窗确认
                  this.popVisible = false
                  this.$message.success('提交成功')
                  this.$emit('ok')
                } else {
                  this.popVisible = true
                }
              })
          }
        }
      })
    },
    handleOk () {
      this.releaseRes()
    },
    vocherVisibleCancel () {
      this.vocherPopVisible = false
    },
    async confirmReleaseResource () {
      await releaseResource(
        {
          ...this.form,
          startDate: this.dateChange(moment(this.form.startDate)),
          endDate: this.dateChange(moment(this.form.endDate)),
          recoveryDate: this.dateChange(moment(this.form.recoveryDate)),
          operation: 1,
          dataSource: 1111
        }
      )
        .then((data) => {
          if (data) {
            this.$emit('ok')
            this.$message.success('提交成功!')
          }
        }).finally(() => {
          this.popVisible = false
        })
    },
    async confirmVocherResource () {
      await releaseVoucherRsource({
        ...this.form,
        startDate: this.dateChange(moment(this.form.startDate)),
        endDate: this.dateChange(moment(this.form.endDate)),
        recoveryDate: this.dateChange(moment(this.form.recoveryDate)),
        operation: 1,
        dataSource: 1111
      }).then((data) => {
        if (data) {
          this.$message.success('提交成功')
          this.$emit('ok')
        } else {
          this.vocherPopVisible = false
        }
      })
    },
    popVisibleCancel () {
      this.popVisible = false
    },
    selectGrantResource (value1, value2) {
      if (value1 && value2) {
        this.visibleGrant = true
        this.queryTable()
      }
    },
    async queryTable () {
      this.isSelectBase = false
      this.isSelectProduct = false
      await querySubsidyType({
        productTypeId: this.form.productTypeId
      }).then(async (data) => {
        this.visibleGrant = true
        if (data !== 2) {
          queryResourceOthers({
            baseId: this.form.baseId,
            productTypeId: this.form.productTypeId
          }).then((data) => {
            this.voucherVisible = false
            this.remainAmount = data.distributionAmount
            this.dataSource = data.resources
          })
        } else {
          await queryResourceAllocation({
            baseId: this.form.baseId,
            productTypeId: this.form.productTypeId
          }).then((data) => {
            this.remainAmount = data.remainAmount
            this.operatorAmout = data.operatorAmout
            this.distributionAmount = data.distributionAmount
            this.dataSource = data.resources
            this.voucherVisible = true
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.amountClass {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  .a-pad {
    margin: 20px 0 20px;
  }
}

/deep/ .ant-modal-content {
  max-height: 835px;
  overflow-y: auto;
}

.ant-form-item {
  margin-bottom: 14px;
}
</style>
